import React from "react";
import { connect } from "react-redux";

import * as productsAPI from "../../../api/products";
import { IProduct } from "../../../models/catalogue.interfaces";
import { IProductID } from "../../../models/nominals";
import { ICompareTile } from "../../../models/product-compare.interfaces";
import { Dispatchers } from "../../configurator/dispatchers";
import { rootProductSelector } from "../../configurator/selectors";
import { TDispatchMapper, TStateMapper } from "../../reducers.interfaces";
import { ProductCompareSelectionTile as ProductCompareSelectionTileComponent } from "../elements/ProductCompareSelectionTile";

interface IOwnProps {
    tile: ICompareTile;
}

interface IReduxProps {
    pageRootProduct: IProductID | null;
}

interface IDispatchProps {
    onSelectRootProduct: (product: IProduct) => void;
}

interface IProps extends IOwnProps, IDispatchProps, IReduxProps {}

interface IState {
    products: IProduct[];
}

// TODO(ssr, LEVEL 6 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 6/10 due to async componentDidMount with API calls, local state management, and Redux connect.
class ProductCompareSelectionTileContainer extends React.Component<
    IProps,
    IState
> {
    public state: IState = {
        products: [],
    };

    componentDidMount() {
        this.loadProduct();
    }

    private readonly onProductSelect = () => {
        if (this.state.products.length > 0) {
            this.props.onSelectRootProduct(this.state.products[0]);
        }
    };

    private async loadProduct() {
        const products = await Promise.all(
            this.props.tile.product_compare_tile.product_ids.map((pid) => {
                const productURL = productsAPI.getProductURL(pid);
                return productsAPI.getProduct(productURL);
            }),
        );
        this.setState({
            products: products,
        });
    }

    render() {
        const isSelected =
            this.props.tile.product_compare_tile.product_id ===
            this.props.pageRootProduct;
        return (
            <div>
                <ProductCompareSelectionTileComponent
                    products={this.state.products}
                    isSelected={isSelected}
                    onProductSelect={this.onProductSelect}
                />
            </div>
        );
    }
}

const mapStateToProps: TStateMapper<"configurator", IReduxProps, IOwnProps> = (
    rootState,
    ownProps,
) => {
    const rootProduct = rootProductSelector(rootState.configurator);

    return {
        ...ownProps,
        pageRootProduct: rootProduct ? rootProduct.id : null,
    };
};

const mapDispatchToProps: TDispatchMapper<IDispatchProps> = (dispatch) => {
    const dispatchers = new Dispatchers(dispatch);

    return {
        onSelectRootProduct: (product) => {
            dispatchers.setSelectedRootProduct(product);
        },
    };
};

export const ProductCompareSelectionTile = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductCompareSelectionTileContainer);
